/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import {
	FormControl, Button, IconButton,
	Typography,
	Box,
	Avatar,
	FormControlLabel,
	Switch,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';

import { DivFormTitle } from './styles';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import moment from 'moment';

const ServiceFilterModal = (props) => {
	const dispatch = useDispatch();

	const [page] = useState(1);
	const [limit] = useState(30);
	const [orderBy] = useState("name");
	const [order] = useState("asc");

	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);

	const [searchTextEquipmentModel, setSearchTextEquipmentModel] = useState('');
	const [equipmentsModelsFormatted, setEquipmentsModelsFormatted] = useState([]);
	const [selectedEquipmentModels, setselectedEquipmentModels] = useState([]);

	const [placesFormatted, setPlacesFormatted] = useState([]);
	const [selectedPlaces, setSelectedPlaces] = useState([]);

	const [searchTextArea, setSearchTextArea] = useState('');
	const [areasFormatted, setAreasFormatted] = useState([]);
	const [selectedAreas, setSelectedAreas] = useState([]);

	const [searchTextEquipmentGroup, setSearchTextEquipmentGroup] = useState('');
  const [equipmentsGroupsFormatted, setEquipmentsGroupsFormatted] = useState([]);
  const [selectedEquipmentGroups, setselectedEquipmentGroups] = useState([]);

	const [searchTextSite, setSearchTextSite] = useState('');
	const [sitesFormatted, setSitesFormatted] = useState([]);
	const [selectedSites, setSelectedSites] = useState([]);

	const [searchTextServiceType, setSearchTextServiceType] = useState('');
	const [serviceTypesFormatted, setServiceTypesFormatted] = useState([]);
	const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);

	const [searchTextFrequency, setSearchTextFrequency] = useState('');
	const [frequenciesFormatted, setFrequenciesFormatted] = useState([]);
	const [selectedFrequencies, setSelectedFrequencies] = useState([]);

	const [searchTextCompanies, setSearchTextCompanies] = useState('');
	const [companiesFormatted, setCompaniesFormatted] = useState([]);
	const [selectedCompanies, setSelectedCompanies] = useState([]);

	const [searchTextUsers, setSearchTextUsers] = useState('');
	const [usersFormatted, setUsersFormatted] = useState([]);
	const [selectedUsers, setSelectedUsers] = useState([]);

	const [searchTextEquipment, setSearchTextEquipment] = useState('');
	const [equipmentsFormatted, setEquipmentsFormated] = useState([]);
	const [selectedEquipment, setSelectedEquipment] = useState(null);

	const [selectedSources, setSelectedSources] = useState([]);

	const [doneInDelay, setDoneInDelay] = useState(false);

	const fetchPlaces = useCallback(
		() => dispatch(actions.fetchPlacesLeafs(selectedSites)),
		[selectedSites]
	);

	const fetchAreas = useCallback(
		() => dispatch(actions.fetchAreas(page, limit, searchTextArea, order, orderBy)),
		[page, limit, searchTextArea, order, orderBy]
	);

	const fetchSites = useCallback(
		() => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
		[page, limit, searchTextSite, order, orderBy]
	);

	const fetchEquipmentsModels = useCallback(
		() => dispatch(actions.fetchEquipmentModels(page, limit, searchTextEquipmentModel, order, orderBy)),
		[page, limit, searchTextEquipmentModel, order, orderBy]
	);

	const fetchEquipmentGroups = useCallback(
    () => dispatch(actions.fetchGroups(page, limit, searchTextEquipmentGroup, order, orderBy)),
    [searchTextEquipmentGroup],
  );

	const fetchServiceTypes = useCallback(
		() => dispatch(actions.fetchServiceTypes(page, limit, searchTextServiceType, order, orderBy)),
		[page, limit, searchTextServiceType, order, orderBy]
	);

	const fetchFrequencies = useCallback(
		() => dispatch(actions.fetchFrequency(page, limit, searchTextFrequency, order, orderBy)),
		[page, limit, searchTextFrequency, order, orderBy]
	);

	const fetchCompanies = useCallback(
		() => dispatch(actions.fetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
		[page, limit, searchTextCompanies, order, orderBy]
	);

	const fetchUsers = useCallback(
		() => dispatch(actions.fetchUsers(page, limit, searchTextUsers, order, orderBy)),
		[page, limit, searchTextUsers, order, orderBy]
	);

	const role = useSelector(state => state.auth.selectedAccess.role);
	const sites = useSelector(state => state.sites.sites);
	const places = useSelector(state => state.places.placesLeafs);
	const areas = useSelector(state => state.areas.areas);
	const equipmentsModels = useSelector(state => state.equipmentModels.equipmentModels);
	const equipmentGroups = useSelector(state => state.groups.groups);
	const serviceTypes = useSelector(state => state.serviceTypes.serviceTypes);
	const frequencies = useSelector(state => state.frequency.frequencies);
	const companies = useSelector(state => state.companies.companies);
	const users = useSelector(state => state.users.users);
	const equipmentsForFilter = useSelector(state => state.services.equipmentsForFilter);

	const filteredSites = useSelector(state => state.sites.selectedSitesPlaces);
	const filteredPlaces = useSelector(state => state.services.filteredPlaces);
	const filteredAreas = useSelector(state => state.services.filteredAreas);
	const filteredCompanies = useSelector(state => state.services.filteredCompanies);
	const filteredEquipmentsModels = useSelector(state => state.services.filteredModels);
	const filteredEquipmentGroups = useSelector(state => state.services.filteredGroups);
	const filteredServiceTypes = useSelector(state => state.services.filteredServiceTypes);
	const filteredFrequencies = useSelector(state => state.services.filteredFrequencies);
	const filteredUsers = useSelector(state => state.services.filteredUsers);
	const filteredStartDate = useSelector(state => state.services.startDate);
	const filteredEndDate = useSelector(state => state.services.endDate);
	const filteredEquipment = useSelector(state => state.services.filteredEquipment);
	const filteredSources = useSelector(state => state.services.filteredSources);
	const filteredDoneInDelay = useSelector(state => state.services.filteredDoneInDelay);

	const loadingSites = useSelector(state => state.sites.loading);
	const loadingEquipmentsModels = useSelector(state => state.equipmentModels.loading);
	const loadingEquipmentGroups = useSelector(state => state.groups.loading);
	const loadingPlaces = useSelector(state => state.places.loading);
	const loadingAreas = useSelector(state => state.areas.loading);
	const loadingCompanies = useSelector(state => state.companies.loading);
	const loadingServiceTypes = useSelector(state => state.serviceTypes.loading);
	const loadingFrequencies = useSelector(state => state.frequency.loading);
	const loadingUsers = useSelector(state => state.users.loading);
	const loadingEquipments = useSelector(state => state.services.loadingEquipments);

	const serviceSources = [
  { value: "web", label: i18n.t('editService.web').toUpperCase() },
  { value: "legacy app", label: i18n.t('editService.legacyApp').toUpperCase() },
  { value: "legacy web", label: i18n.t('editService.legacyWeb').toUpperCase() },
  { value: "legacy", label: i18n.t('editService.legacy').toUpperCase() },
  { value: "app qrcode", label: i18n.t('editService.appQrcode').toUpperCase() },
  { value: "app calendar", label: i18n.t('editService.appCalendar').toUpperCase() },
  { value: "app places", label: i18n.t('editService.appPlaces').toUpperCase() },
  { value: "app allequipments", label: i18n.t('editService.appAllEquipments').toUpperCase() },
  { value: "app map", label: i18n.t('editService.appMap').toUpperCase() },
  { value: "app", label: i18n.t('editService.app').toUpperCase() },
];
;

	const fetchEquipments = useCallback(
		() => dispatch(actions.servicesTableFiltersFetchEquipments(page, limit, searchTextEquipment, order, 'equipmentModel.label', filteredSites, filteredPlaces, filteredEquipmentsModels, filteredEquipmentGroups, filteredAreas, filteredCompanies)),
		[page, limit, searchTextEquipment, order, orderBy, filteredSites, filteredPlaces, filteredEquipmentsModels, filteredEquipmentGroups, filteredAreas, filteredCompanies]
	);

	useEffect(() => {
		handleInputChangeSites(filteredSites);
		handleInputChangePlaces(filteredPlaces);
		handleInputChangeAreas(filteredAreas);
		handleInputChangeCompanies(filteredCompanies);
		handleInputChangeEquipmentsModels(filteredEquipmentsModels);
		handleInputChangeEquipmentGroups(filteredEquipmentGroups);
		handleInputChangeServiceTypes(filteredServiceTypes);
		handleInputChangeFrequencies(filteredFrequencies);
		handleInputChangeUsers(filteredUsers);
		setStartDate(filteredStartDate ? filteredStartDate : null);
		setEndDate(filteredEndDate ? filteredEndDate : null);
		handleInputChangeEquipment(filteredEquipment);
		handleInputChangeSources(filteredSources);
		setDoneInDelay(filteredDoneInDelay ? filteredDoneInDelay : false);
	}, []);

	useEffect(() => {
		fetchPlaces(selectedSites);
	}, [selectedSites]);

	useEffect(() => {
		fetchAreas(limit, searchTextArea, order, orderBy);
	}, [searchTextArea]);

	useEffect(() => {
		if (role !== 'contractor') {
      fetchCompanies(limit, searchTextCompanies, order, orderBy);
    }
	}, [searchTextCompanies]);


	useEffect(() => {
		fetchSites(limit, searchTextSite, order, orderBy);
	}, [searchTextSite]);

	useEffect(() => {
		fetchEquipmentsModels(limit, searchTextEquipmentModel, order, orderBy);
	}, [searchTextEquipmentModel]);

	useEffect(() => {
    fetchEquipmentGroups(limit, searchTextEquipmentGroup, order, orderBy);
  }, [searchTextEquipmentGroup]);

	useEffect(() => {
		fetchServiceTypes(limit, searchTextServiceType, order, orderBy);
	}, [searchTextServiceType]);

	useEffect(() => {
		fetchFrequencies(limit, searchTextFrequency, order, orderBy);
	}, [searchTextFrequency]);

	useEffect(() => {
		fetchUsers();
	}, [searchTextUsers]);

	useEffect(() => {
		fetchEquipments();
	}, [searchTextEquipment])

	useEffect(() => {
		const dataToFormat = places;
		let formattedData = [];
		dataToFormat.rows.forEach(place => formattedData.push({ value: place._id, label: place.path }));
		setPlacesFormatted(formattedData);
	}, [places])

	useEffect(() => {
		const dataToFormat = areas;
		let formattedData = [];
		dataToFormat.rows.forEach(area => formattedData.push({ value: area._id, label: area.name }));
		setAreasFormatted(formattedData);
	}, [areas])

	useEffect(() => {
		const dataToFormat = sites;
		let formattedData = [];
		dataToFormat.rows.forEach(site => formattedData.push({ value: site._id, label: site.name, ...site }));
		setSitesFormatted(formattedData);
	}, [sites])

	useEffect(() => {
		const dataToFormat = equipmentsModels;
		let formattedData = [];
		dataToFormat.rows.forEach(equipment => formattedData.push({ value: equipment._id, label: equipment.name }));
		setEquipmentsModelsFormatted(formattedData);
	}, [equipmentsModels])

	useEffect(() => {
    const dataToFormat = equipmentGroups;
    const formattedData = [];
    dataToFormat.rows.forEach(equipmentGroup => formattedData.push({ value: equipmentGroup._id, label: equipmentGroup.name }));
    setEquipmentsGroupsFormatted(formattedData);
  }, [equipmentGroups]);

	useEffect(() => {
		const dataToFormat = serviceTypes;
		let formattedData = [];
		dataToFormat.rows.forEach(serviceType => formattedData.push({ value: serviceType._id, label: serviceType.name }));
		setServiceTypesFormatted(formattedData);
	}, [serviceTypes])

	useEffect(() => {
		const dataToFormat = frequencies;
		let formattedData = [];
		dataToFormat.rows.forEach(frequency => formattedData.push({ value: frequency._id, label: frequency.name }));
		setFrequenciesFormatted(formattedData);
	}, [frequencies])

	useEffect(() => {
		const dataToFormat = companies;
		let formattedData = [];
		dataToFormat.rows.forEach(company => formattedData.push({ value: company._id, label: company.name }));
		setCompaniesFormatted(formattedData);
	}, [companies])

	useEffect(() => {
		const dataToFormat = users;
		let formattedData = [];
		dataToFormat.rows.forEach(user => formattedData.push({ value: user._id, label: user.name }));
		setUsersFormatted(formattedData);
	}, [users])

	useEffect(() => {
		setEquipmentsFormated(
			equipmentsForFilter.map((equipment) => ({ value: equipment._id, label: equipment.equipmentModel.name, equipment }))
		)
	}, [equipmentsForFilter])

	const handleInputChangeSelectorAreas = (text) => {
		setSearchTextArea(text);
	}

	const handleInputChangeSelectorCompanies = (text) => {
		setSearchTextCompanies(text);
	}

	const handleInputChangeSelectorSites = (text) => {
		setSearchTextSite(text);
	}

	const handleInputChangeSelectorEquipmentsModels = (text) => {
		setSearchTextEquipmentModel(text);
	}

	const handleInputChangeSelectorEquipmentGroup = (text) => {
    setSearchTextEquipmentGroup(text);
  };

	const handleInputChangeSelectorServiceTypes = (text) => {
		setSearchTextServiceType(text);
	}

	const handleInputChangeSelectorFrequencies = (text) => {
		setSearchTextFrequency(text);
	}

	const handleInputChangeSelectorUsers = (text) => {
		setSearchTextUsers(text);
	}

		const handleInputChangeSelectorEquipment = (text) => {
		setSearchTextEquipment(text);
	}

	const handleInputChangePlaces = selected => {
		setSelectedPlaces(selected);
	}

	const handleInputChangeAreas = selected => {
		setSelectedAreas(selected);
	}

	const handleInputChangeCompanies = selected => {
		setSelectedCompanies(selected);
	}

	const handleInputChangeEquipmentsModels = selected => {
		setselectedEquipmentModels(selected);
	}

	const handleInputChangeEquipmentGroups = (selected) => {
		setselectedEquipmentGroups(selected);
	};

	const handleInputChangeServiceTypes = selected => {
		setSelectedServiceTypes(selected);
	}

	const handleInputChangeFrequencies = selected => {
		setSelectedFrequencies(selected);
	}

	const handleInputChangeUsers = selected => {
		setSelectedUsers(selected);
	}

	const handleInputChangeSources = selected => {
		setSelectedSources(selected);
	}

	const handleInputChangeSites = selected => {
		if(selected) {
			const dataFromRedux = selected
			let returnArray = []
			dataFromRedux.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
			setSelectedSites(returnArray);
		} else {
			setSelectedSites([]);
		}
	}

	const handleInputChangeEquipment = (selected) => {
		setSelectedEquipment(selected);
	}

	const verifyStartDateRange = () => {
		if(moment(endDate) < moment(startDate)) {
			setStartDate(endDate)
		}
	}

	const handleClickFilter = () => {
		dispatch(actions.setSitePlaces(selectedSites));
		dispatch(actions.filterServicePlaces(selectedPlaces));
		dispatch(actions.filterServiceAreas(selectedAreas));
		dispatch(actions.filterServiceModels(selectedEquipmentModels));
		dispatch(actions.filterServiceGroups(selectedEquipmentGroups));
		dispatch(actions.filterServiceServiceTypes(selectedServiceTypes));
		dispatch(actions.filterServiceFrequencies(selectedFrequencies));
		dispatch(actions.filterServiceUsers(selectedUsers));
		dispatch(actions.filterServiceCompanies(selectedCompanies));
		dispatch(actions.filterServiceStartDate(startDate));
		dispatch(actions.filterServiceEndDate(endDate));
		dispatch(actions.servicesTableFiltersSetSelectedEquipment(selectedEquipment));
		dispatch(actions.filterServiceSources(selectedSources));
		dispatch(actions.filterServiceDoneInDelay(doneInDelay));
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedPlaces([])
		setSelectedAreas([])
		setSelectedCompanies([])
		setselectedEquipmentModels([])
		setselectedEquipmentGroups([])
		setSelectedServiceTypes([])
		setSelectedFrequencies([])
		setSelectedUsers([])
		setStartDate(null)
		setEndDate(null)
		setSelectedEquipment(null);
		setSelectedSites([]);
		setDoneInDelay(false);
	}

	const EquipmentOption = ({ value, label, equipment }) => {
			if (!equipment) return
	
			return (
				<Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
					 {equipment.photo?.url ?
					<Avatar src={equipment.photo?.url} sx={styles.avatar} />
					:
					<Avatar sx={styles.avatarSmallText}>
						PHOTO
					</Avatar>
				}
					<Box sx={{marginLeft: '10px'}}>
						<Typography sx={{ fontWeight: 'bold' }}>{label}</Typography>
						<Typography sx={{ fontSize: 12 }}>{i18n.t('scheduledServicesDraggableCard.serialNumber')}{equipment.serialNumber}</Typography>
						<Typography sx={{ fontSize: 12 }}>{i18n.t('scheduledServicesDraggableCard.place')}{equipment.place.path}</Typography>
					</Box>
				</Box>
			)
		}

	return (
        <div style={styles.container}>
			<DivFormTitle style={styles.headerContainer}>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList style={{ marginRight: '1rem' }} />
					{i18n.t('filterListModalFilterService.filter')}
					{((selectedPlaces && selectedPlaces.length > 0)
					|| (selectedEquipmentModels && selectedEquipmentModels.length > 0)
					|| (selectedEquipmentGroups && selectedEquipmentGroups.length > 0)
					|| (selectedAreas && selectedAreas.length > 0)
					|| (selectedSites && selectedSites.length > 0)
					|| (selectedCompanies && selectedCompanies.length > 0)
					|| (selectedServiceTypes && selectedServiceTypes.length > 0)
					|| (selectedFrequencies && selectedFrequencies.length > 0)
					|| (selectedUsers && selectedUsers.length > 0))
					|| (selectedSources && selectedSources.length > 0)
					|| (doneInDelay)
					&& <div style={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('filterListModalFilterService.clear')}</div>}
				</div>
				<IconButton onClick={props.closeModal} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</DivFormTitle>
			<div style={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingSites}
						label={i18n.t('autocompleteModalFilterService.site')}
						data={sitesFormatted}
						onSelectValue={handleInputChangeSites}
						valueSelected={selectedSites}
						newSearchText={handleInputChangeSelectorSites}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipmentsModels}
						label={i18n.t('autocompleteModalFilterService.equipments')}
						data={equipmentsModelsFormatted}
						onSelectValue={handleInputChangeEquipmentsModels}
						valueSelected={selectedEquipmentModels}
						newSearchText={handleInputChangeSelectorEquipmentsModels}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            loading={loadingEquipmentGroups}
            label={i18n.t('autocompleteModalFilterService.equipmentGroups')}
            data={equipmentsGroupsFormatted}
            onSelectValue={handleInputChangeEquipmentGroups}
            valueSelected={selectedEquipmentGroups}
            newSearchText={handleInputChangeSelectorEquipmentGroup}
            isMulti
          />
        </FormControl>
					<FormControl variant="standard" fullWidth margin='normal'>
						<Autocomplete
							loading={loadingEquipments}
							label={i18n.t('scheduledServicesServicesForSchedulingFilterModal.equipments')}
							data={equipmentsFormatted}
							onSelectValue={handleInputChangeEquipment}
							valueSelected={selectedEquipment}
							newSearchText={handleInputChangeSelectorEquipment}
							id="equipment"
							customizedOption={EquipmentOption}
							showDataWithoutComponentTextFilter={true}
						/>
					</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingPlaces}
						label={i18n.t('autocompleteModalFilterService.place')}
						data={placesFormatted}
						onSelectValue={handleInputChangePlaces}
						valueSelected={selectedPlaces}
						newSearchText={() => {}}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingAreas}
						label={i18n.t('autocompleteModalFilterService.area')}
						data={areasFormatted}
						onSelectValue={handleInputChangeAreas}
						valueSelected={selectedAreas}
						newSearchText={handleInputChangeSelectorAreas}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingServiceTypes}
						label={i18n.t('autocompleteModalFilterService.serviceTypes')}
						data={serviceTypesFormatted}
						onSelectValue={handleInputChangeServiceTypes}
						valueSelected={selectedServiceTypes}
						newSearchText={handleInputChangeSelectorServiceTypes}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingFrequencies}
						label={i18n.t('autocompleteModalFilterService.frequencies')}
						data={frequenciesFormatted}
						onSelectValue={handleInputChangeFrequencies}
						valueSelected={selectedFrequencies}
						newSearchText={handleInputChangeSelectorFrequencies}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingCompanies}
						label={i18n.t('autocompleteModalFilterService.companies')}
						data={companiesFormatted}
						onSelectValue={handleInputChangeCompanies}
						valueSelected={selectedCompanies}
						newSearchText={handleInputChangeSelectorCompanies}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingUsers}
						label={i18n.t('autocompleteModalFilterService.performedBy')}
						data={usersFormatted}
						onSelectValue={handleInputChangeUsers}
						valueSelected={selectedUsers}
						newSearchText={handleInputChangeSelectorUsers}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={false}
						label={i18n.t('editService.source').replace(':', '')}
						data={serviceSources}
						onSelectValue={handleInputChangeSources}
						valueSelected={selectedSources}
						newSearchText={() => {}}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<FormControlLabel
						control={<Switch checked={doneInDelay} onChange={e => setDoneInDelay(e.target.checked)} />}
						label={i18n.t('autocompleteModalFilterService.doneInDelay')}
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('keyboardDatePickerModalFilterService.from')}
						margin='normal'
						value={startDate && new Date(startDate)}
						onChange={date => setStartDate(date ?  date : null)}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', } }}
						/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<DatePicker
						label={i18n.t('keyboardDatePickerModalFilterService.to')}
						margin='normal'
						value={endDate && new Date(endDate)}
						onChange={date => setEndDate(date ? date : null)}
						onBlurCapture={verifyStartDateRange}
						format="dd/MM/yyyy"
						slotProps={{ textField: { variant: 'standard', } }}
						/>
				</FormControl>
			</div>
			<div style={styles.footerContainer}>
				<div
					onClick={props.closeModal}
					style={styles.buttonCancel}
				>
				{i18n.t('divModalFilterService.cancel')}
				</div>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					style={styles.button}
				>
				{i18n.t('divModalFilterService.ok')}
				</Button>
			</div>
		</div>
    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem',
		marginLeft: '2rem',
		color: '#fff',
		cursor: 'pointer',
		textDecoration: 'underline'
	}
}


export default ServiceFilterModal;

